import { Injectable } from '@angular/core';

import { PaymentsCustomApiService } from '@payments/common-utils';

@Injectable({
    providedIn: 'root',
})
export class QdApiService extends PaymentsCustomApiService {}
